"use strict";

angular.module('PatientApp').factory('FullstoryService', ['VuexStore', function (VuexStore) {
  return {
    log: function log(optionalLogLevel, logMessage) {
      return VuexStore.dispatch('logFullStory', {
        optionalLogLevel: optionalLogLevel,
        logMessage: logMessage
      });
    },
    identify: function identify(currentUser) {
      return VuexStore.dispatch('identifyFullStory', currentUser);
    }
  };
}]);